import {Component, Input} from '@angular/core';
import {EventHistoryStatus} from '../shared/webhook-event.model';

@Component({
  selector: 'app-webhook-event-history-status',
  templateUrl: './webhook-event-history-status.component.html',
  styleUrls: ['./webhook-event-history-status.component.scss']
})
export class WebhookEventHistoryStatusComponent {

  @Input()
  public status: EventHistoryStatus;

  public EventHistoryStatus = EventHistoryStatus;

}
